export const isCancelledMeetingItemClass = (itemClass: string) =>
    itemClass?.match(/^ipm\.schedule\.meeting\.canceled/i);
